import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({//Estílos solamente del componente "LoginComponent"
  container: {
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    //justifyContent: 'center !important',
    height: '100vh',
    width: '100%',
    overflow: 'hidden',
    position: 'relative'
  },
  backButton: {
      position: 'absolute',
      top: 0,
      left: 0,
      '&&:focus': {
        outline: 'none'
      }
  },
  imageTop: {
      marginTop: '25vh'
  },
  title: {
      marginTop: '10vh',
      fontWeight: 600,
      //color: '#C20E30',
      //border: '1px solid #C20E30',
  },
  version: {
      marginTop: '1vh',
      fontWeight: 600,
      color:theme.palette.primary.main,
  },
  bottomText: {
      position: 'absolute',
      bottom: 250,
      width: '25%',
      ['@media only screen and (max-width: 600px)']: {
        width: '90%',
        left: 20,
        right: 20,
      },
      textAlign: 'center'
  }
}))
